import React from "react";
import PropTypes from "prop-types";
import parse from "html-react-parser";
import ArticleInfo from "../article-info/articleInfo";
import { ARTICLE_INFO_TYPE } from "../article-info/articleInfo.constants";
import Pill from "../pill/pill";
import { PILL_TYPE } from "../pill/pill.constant";
import FeaturedImage from "../featured-image/featuredImage";
import "./postCard.scss";
import { Link } from "gatsby";
import { getBlogPostUri } from "../../../utils/buzzHelper";
import {
  FALLBACK_IMG,
  FALLBACK_IMG_ALT,
  POST_CARD_DATA,
} from "./postCard.constant";
import { getImgUrl } from "../../../constants/imgVariants";
import { triggerBuzzClickEvent } from "../../../utils/garfieldHelpers";
import { EVENT_NAMES } from "../../../constants/garfieldEvents";

const PostCard = ({
  post,
  cardOrientation,
  imgPosition,
  imgVariant,
  sectionId,
  source,
  flow,
}) => {
  const {
    title,
    categories,
    author,
    seo,
    date,
    slug,
  } = post;

  const handlePostCardClick = () => {
    triggerBuzzClickEvent(
      EVENT_NAMES.ARTICLE_CARD_CLICKED,
      {
        [POST_CARD_DATA.TITLE]: title,
        [POST_CARD_DATA.CATEGORY]:
          categories?.nodes[0]?.name,
        [POST_CARD_DATA.URL]: slug,
        [POST_CARD_DATA.PUBLISH_DATE]: date,
      },
      sectionId,
      source,
      flow
    );
  };

  const featuredImage = post.featuredImage
    ? {
        fluid:
          post.featuredImage?.node?.localFile
            ?.childImageSharp?.fluid,
        alt: post.featuredImage?.node?.alt || "",
      }
    : null;

  const categoryObj =
    categories?.nodes?.length > 0 && categories.nodes[0];

  return (
    <Link
      to={getBlogPostUri(post)}
      itemProp="url"
      className={`link ${cardOrientation}`}
      onClick={handlePostCardClick}
    >
      <div
        className={`post-card ${cardOrientation || ""} ${
          imgPosition || ""
        }`}
      >
        <div
          className={`featured-image ${cardOrientation}`}
        >
          <FeaturedImage
            imgSrc={getImgUrl(post?.slug, imgVariant)}
            postTitle={post?.title}
            postFeaturedImg={featuredImage}
            fallBackImg={FALLBACK_IMG}
            fallBackImgAlt={title || FALLBACK_IMG_ALT}
          />
        </div>
        <div className="content">
          <div className="post-category">
            {categoryObj && (
              <Pill
                data={categoryObj}
                pillType={PILL_TYPE.CATEGORY}
                sectionId={sectionId}
                source={source}
                flow={flow}
              />
            )}
          </div>
          {title && (
            <h3 className={`title ${cardOrientation}`}>
              {parse(title)}
            </h3>
          )}

          <ArticleInfo
            articleAuthor={author?.node}
            readingTime={seo?.readingTime}
            publishDate={date}
            articleInfoType={ARTICLE_INFO_TYPE.COMMON}
          />
        </div>
      </div>
    </Link>
  );
};

PostCard.propTypes = {
  post: PropTypes.object,
  cardOrientation: PropTypes.string,
  imgPosition: PropTypes.string,
  imgVariant: PropTypes.string,
  sectionId: PropTypes.string,
  source: PropTypes.string,
  flow: PropTypes.string,
};

export default PostCard;
